import React from "react";
import { Main } from "./routes/Main";
import "./theme.css";

function App() {
  return (
    <div className="App white-mode">
      <Main />
    </div>
  );
}

export default App;
